import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PlusIcon = ({ sx, ...props }: SvgIconProps & { strokeColor?: string }) => {
  return (
    <SvgIcon viewBox='0 0 22 22' sx={{ height: '22px', width: '22px', ...sx }} {...props}>
      <path
        d='M11.0002 4.58301V17.4163M4.5835 10.9997H17.4168'
        stroke={'currentColor'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default PlusIcon;
